import * as React from 'react';
import MaturityCellDateSelector from '../MaturityCellDateSelector';
import MaturityCellDatePicker from '../MaturityCellDatePicker';
import PopupContext from 'contexts/PopupContext';
import Maturity from '../../../../../models/data/Maturity';
const MaturityPopUp = ({ data, hasOverride, hasValue, isDisabled, save }) => {
    const [isValueConfirm, setValueConfirm] = React.useState(false);
    const [value, setValue] = React.useState(data?.override?.maturity ?? data?.data?.maturity);
    const { setBlockClose } = React.useContext(PopupContext);
    React.useEffect(() => setBlockClose(true), [setBlockClose]);
    const onChange = React.useCallback((event) => {
        const date = event.target.value;
        const newValue = new Maturity({
            date: {
                dayOfMonth: date.getDate(),
                monthValue: date.getMonth() + 1,
                year: date.getFullYear()
            }
        });
        setValue(newValue);
        setValueConfirm(true);
        setBlockClose(false);
    }, [setBlockClose]);
    return isValueConfirm && value !== undefined ? (React.createElement(MaturityCellDateSelector, { isDisabled: isDisabled, setValueConfirm: setValueConfirm, save: save, value: value })) : (React.createElement(MaturityCellDatePicker, { hasOverride: hasOverride, hasValue: hasValue, isDisabled: isDisabled, onChange: onChange, save: save, value: value }));
};
export default MaturityPopUp;
